import { EmployerAgreementSourcesService_employerAgreementSourcesServiceGetAllSourceStops } from '@festina/life-general-types/life/hooks/EmployerAgreementSourcesStopsService_employerAgreementSourcesServiceGetAllSourceStops'

export const useFetchAgreementStopHistory =
  EmployerAgreementSourcesService_employerAgreementSourcesServiceGetAllSourceStops.useQuery
